import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useRef, useEffect } from "react";
import layerBottom from "@/assets/img/common/content/layer_bottom.png";
import layerMiddle from "@/assets/img/common/content/layer_middle.png";
import layerTop from "@/assets/img/common/content/layer_top.png";
import layerTopmost from "@/assets/img/common/content/core_cube.png";
import centerBeamImg from "@/assets/img/common/content/center_beam.png";
import centerItemA from "@/assets/img/common/content/conter_item_a.png";
import centerItemB from "@/assets/img/common/content/conter_item_b.png";
import centerItemC from "@/assets/img/common/content/conter_item_c.png";
import bottomItem from "@/assets/img/common/content/bottom_item.png";
import topItem from "@/assets/img/common/content/top_item.png";
import topInfo from "@/assets/img/common/content/top_info.png";
// 数据配置
const bottomMenu = [
    { id: "plan", text: "计划", pos: { x: 20, y: 50 } },
    { id: "purchase", text: "采购", pos: { x: 35, y: 55 } },
    { id: "check", text: "验收", pos: { x: 50, y: 58 } },
    { id: "stock-in", text: "入库", pos: { x: 65, y: 55 } },
    { id: "stock-out", text: "出库", pos: { x: 80, y: 50 } },
];
const topMenu = [
    { id: 1, text: "盘点", pos: { x: 50, y: 36 } },
    { id: 2, text: "卡片", pos: { x: 27, y: 60 } },
    { id: 3, text: "报表", pos: { x: 36, y: 76 } },
    { id: 4, text: "库房", pos: { x: 64, y: 76 } },
    { id: 5, text: "报废", pos: { x: 73, y: 67 } },
];
const assetItems = [
    { id: "rent", text: "出租", pos: { x: 23, y: 40 }, img: centerItemA },
    { id: "borrow", text: "借用", pos: { x: 40, y: 25 }, img: centerItemB },
    { id: "maintain", text: "维保", pos: { x: 63, y: 25 }, img: centerItemC },
    { id: "mortgage", text: "抵押", pos: { x: 82, y: 40 }, img: centerItemA },
    { id: "transfer", text: "调拨", pos: { x: 33, y: 64 }, img: centerItemB },
    { id: "tech-upgrade", text: "技改", pos: { x: 56, y: 70 }, img: centerItemC },
    { id: "dispose", text: "处置", pos: { x: 76, y: 60 }, img: centerItemA },
];
// 表格样式
const baseTableCellStyles = {
    borderBottom: "0.01rem solid rgb(0, 255, 255, .3)",
    borderRight: "0.01rem solid rgb(0, 255, 255, .2)",
    textAlign: "center",
    padding: "0.04rem 0",
    fontSize: "0.11rem",
};
const tableStyles = {
    container: {
        width: "3.2rem",
        height: "2rem",
        paddingLeft: "0.54rem",
    },
    table: {
        width: "100%",
        color: "#00ffff",
        borderCollapse: "separate",
        borderSpacing: 0,
        backgroundColor: "rgb(6, 42, 88)",
        tableLayout: "fixed",
    },
    tableCell: baseTableCellStyles,
    theadTh: {
        ...baseTableCellStyles,
        fontWeight: "bold",
        backgroundColor: "rgb(6, 42, 88)",
        position: "sticky",
        top: 0,
        zIndex: 10,
    },
    tableBodyWrapper: {
        maxHeight: "1.7rem",
        overflowY: "auto",
        width: "100%",
        marginTop: "0.04rem",
    },
    lastCell: {
        borderRight: "none",
    },
    lastRow: {
        borderBottom: "none",
    },
    scrollbarHidden: {
        scrollbarWidth: "none",
        msOverflowStyle: "none",
    },
    activeMenu: {
        transform: "translate(-50%, -50%) scale(1.1)",
        filter: "brightness(1.3)",
    },
    inactiveMenu: {
        transform: "translate(-50%, -50%) scale(0.9)",
        filter: "brightness(0.7)",
        opacity: 0.8,
    },
};
// 盘点详情组件
const PlanDetail = ({ isActive }) => {
    const scrollRef = useRef(null);
    const timeTabs = [
        { value: "planName", name: "计划名称" },
        { value: "subsystemLabel", name: "盘点范围" },
        { value: "taskDate", name: "任务时间" },
        { value: "statusName", name: "计划状态" },
        { value: "planRateName", name: "盘点进度" },
        { value: "detail", name: "详情" },
    ];
    const dataSource = [
        {
            id: "plan-1",
            planName: "2025资产抽盘",
            taskDate: "2025-09-021～2025-09-025",
            subsystemLabel: "固定资产",
            statusName: "已发布",
            planRateName: "未开始",
            detail: "详情",
        },
        {
            id: "plan-2",
            planName: "仓库复盘",
            taskDate: "2025-09-17～2025-09-22",
            subsystemLabel: "科研物资",
            statusName: "已发布",
            planRateName: "盘点中",
            detail: "详情",
        },
        {
            id: "plan-3",
            planName: "2025利旧资产全盘",
            taskDate: "2025-09-010～2025-09-20",
            subsystemLabel: "利旧资产",
            statusName: "审核通过",
            planRateName: "盘结",
            detail: "详情",
        },
    ];
    useEffect(() => {
        let timer = null;
        if (isActive && scrollRef.current) {
            timer = setInterval(() => {
                if (!scrollRef.current)
                    return;
                const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
                const maxScroll = scrollHeight - clientHeight;
                if (maxScroll <= 0)
                    return;
                scrollRef.current.scrollTop =
                    scrollTop >= maxScroll ? 0 : scrollTop + 1;
            }, 50);
        }
        return () => {
            if (timer)
                clearInterval(timer);
        };
    }, [isActive]);
    return (_jsx("div", { style: tableStyles.container, children: _jsx("div", { ref: scrollRef, style: {
                ...tableStyles.tableBodyWrapper,
                ...tableStyles.scrollbarHidden,
            }, children: _jsxs("table", { style: tableStyles.table, children: [_jsx("thead", { children: _jsx("tr", { children: timeTabs.map((tab, idx) => (_jsx("th", { style: {
                                    ...tableStyles.theadTh,
                                    ...(idx === timeTabs.length - 1
                                        ? tableStyles.lastCell
                                        : {}),
                                }, children: tab.name }, `th-${tab.value}`))) }) }), _jsx("tbody", { children: dataSource.map((row // 使用数据ID作为key
                        ) => (_jsx("tr", { children: timeTabs.map((tab, colIdx) => (_jsx("td", { style: {
                                    ...tableStyles.tableCell,
                                    ...(colIdx === timeTabs.length - 1
                                        ? tableStyles.lastCell
                                        : {}),
                                    ...(row.id === dataSource[dataSource.length - 1].id
                                        ? tableStyles.lastRow
                                        : {}),
                                }, children: row[tab.value] }, `${row.id}-${tab.value}`))) }, row.id))) })] }) }) }));
};
// 卡片详情组件
const CardDetail = ({ isActive }) => {
    const scrollRef = useRef(null);
    const timeTabs = [
        { value: "subsystemLabel", name: "类别" },
        { value: "assetCount", name: "资产数量（项）" },
        { value: "labelCount", name: "标签数量（个）" },
        { value: "files", name: "档案文件（条）" },
        { value: "slaves", name: "附属资产（项）" },
        { value: "dynamics", name: "资产动态（条）" },
    ];
    const dataSource = [
        {
            id: "card-1",
            subsystemLabel: "固定资产",
            assetCount: 1269,
            labelCount: 1269,
            files: 635,
            slaves: 19,
            dynamics: 2413,
        },
        {
            id: "card-2",
            subsystemLabel: "利旧资产",
            assetCount: 1000,
            labelCount: 1000,
            files: 289,
            slaves: 0,
            dynamics: 33,
        },
        {
            id: "card-3",
            subsystemLabel: "科研物资",
            assetCount: 734,
            labelCount: 734,
            files: 360,
            slaves: 0,
            dynamics: 99,
        },
        {
            id: "card-4",
            subsystemLabel: "三剂物资",
            assetCount: 788,
            labelCount: 0,
            files: 120,
            slaves: 0,
            dynamics: 120,
        },
        {
            id: "card-5",
            subsystemLabel: "低耗用品",
            assetCount: 485,
            labelCount: 485,
            files: 210,
            slaves: 0,
            dynamics: 1620,
        },
    ];
    useEffect(() => {
        let timer = null;
        if (isActive && scrollRef.current) {
            timer = setInterval(() => {
                if (!scrollRef.current)
                    return;
                const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
                const maxScroll = scrollHeight - clientHeight;
                if (maxScroll <= 0)
                    return;
                scrollRef.current.scrollTop =
                    scrollTop >= maxScroll ? 0 : scrollTop + 1;
            }, 50);
        }
        return () => {
            if (timer)
                clearInterval(timer);
        };
    }, [isActive]);
    return (_jsx("div", { style: tableStyles.container, children: _jsx("div", { ref: scrollRef, style: {
                ...tableStyles.tableBodyWrapper,
                ...tableStyles.scrollbarHidden,
            }, children: _jsxs("table", { style: tableStyles.table, children: [_jsx("thead", { children: _jsx("tr", { children: timeTabs.map((tab, idx) => (_jsx("th", { style: {
                                    ...tableStyles.theadTh,
                                    ...(idx === timeTabs.length - 1
                                        ? tableStyles.lastCell
                                        : {}),
                                }, children: tab.name }, `th-${tab.value}`))) }) }), _jsx("tbody", { children: dataSource.map((row // 使用数据ID作为key
                        ) => (_jsx("tr", { children: timeTabs.map((tab, colIdx) => (_jsx("td", { style: {
                                    ...tableStyles.tableCell,
                                    ...(colIdx === timeTabs.length - 1
                                        ? tableStyles.lastCell
                                        : {}),
                                    ...(row.id === dataSource[dataSource.length - 1].id
                                        ? tableStyles.lastRow
                                        : {}),
                                }, children: row[tab.value] }, `${row.id}-${tab.value}`))) }, row.id))) })] }) }) }));
};
// 台账详情组件
const LedgerDetail = ({ isActive }) => {
    const scrollRef = useRef(null);
    const timeTabs = [
        { value: "subsystemLabel", name: "类别" },
        { value: "table1", name: "报表1" },
        { value: "table2", name: "报表2" },
        { value: "table3", name: "报表3" },
        { value: "table4", name: "报表4" },
        { value: "table5", name: "报表5" },
    ];
    const dataSource = [
        {
            id: "ledger-1",
            subsystemLabel: "固定资产",
            table1: "领导驾驶仓",
            table2: "资产价值明细账",
            table3: "资产使用明细表",
            table4: "资产管理明细表",
            table5: "",
        },
        {
            id: "ledger-2",
            subsystemLabel: "利旧资产",
            table1: "领导驾驶仓",
            table2: "",
            table3: "资产使用明细表",
            table4: "资产管理明细表",
            table5: "",
        },
        {
            id: "ledger-3",
            subsystemLabel: "科研物资",
            table1: "领导驾驶仓",
            table2: "物资明细账",
            table3: "物资分类统计账",
            table4: "",
            table5: "",
        },
        {
            id: "ledger-4",
            subsystemLabel: "三剂物资",
            table1: "领导驾驶仓",
            table2: "采购表",
            table3: "加工表",
            table4: "销售表",
            table5: "质量报表",
        },
    ];
    useEffect(() => {
        let timer = null;
        if (isActive && scrollRef.current) {
            timer = setInterval(() => {
                if (!scrollRef.current)
                    return;
                const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
                const maxScroll = scrollHeight - clientHeight;
                if (maxScroll <= 0)
                    return;
                scrollRef.current.scrollTop =
                    scrollTop >= maxScroll ? 0 : scrollTop + 1;
            }, 50);
        }
        return () => {
            if (timer)
                clearInterval(timer);
        };
    }, [isActive]);
    return (_jsx("div", { style: tableStyles.container, children: _jsx("div", { ref: scrollRef, style: {
                ...tableStyles.tableBodyWrapper,
                ...tableStyles.scrollbarHidden,
            }, children: _jsxs("table", { style: tableStyles.table, children: [_jsx("thead", { children: _jsx("tr", { children: timeTabs.map((tab, idx) => (_jsx("th", { style: {
                                    ...tableStyles.theadTh,
                                    ...(idx === timeTabs.length - 1
                                        ? tableStyles.lastCell
                                        : {}),
                                }, children: tab.name }, `th-${tab.value}`))) }) }), _jsx("tbody", { children: dataSource.map((row // 使用数据ID作为key
                        ) => (_jsx("tr", { children: timeTabs.map((tab, colIdx) => (_jsx("td", { style: {
                                    ...tableStyles.tableCell,
                                    ...(colIdx === timeTabs.length - 1
                                        ? tableStyles.lastCell
                                        : {}),
                                    ...(row.id === dataSource[dataSource.length - 1].id
                                        ? tableStyles.lastRow
                                        : {}),
                                }, children: row[tab.value] }, `${row.id}-${tab.value}`))) }, row.id))) })] }) }) }));
};
// 库房详情组件
const WarehouseDetail = ({ isActive }) => {
    const scrollRef = useRef(null);
    const timeTabs = [
        { value: "houseName", name: "名称" },
        { value: "subsystemLabel", name: "资产类型" },
        { value: "leader", name: "管理人" },
        { value: "table", name: "仓库报表" },
    ];
    const dataSource = [
        {
            id: "warehouse-1",
            houseName: "中心库",
            subsystemLabel: "固定资产",
            leader: "姬兆兵",
            table: "详情",
        },
        {
            id: "warehouse-2",
            houseName: "三剂大库",
            subsystemLabel: "科研物资",
            leader: "赵刚",
            table: "详情",
        },
        {
            id: "warehouse-3",
            houseName: "三剂小库",
            subsystemLabel: "科研物资",
            leader: "赵刚",
            table: "详情",
        },
        {
            id: "warehouse-4",
            houseName: "闵行试剂库",
            subsystemLabel: "科研物资",
            leader: "叶萌",
            table: "详情",
        },
        {
            id: "warehouse-5",
            houseName: "康桥试剂库",
            subsystemLabel: "科研物资",
            leader: "葛寅睿",
            table: "详情",
        },
        {
            id: "warehouse-6",
            houseName: "废旧物资库",
            subsystemLabel: "科研物资",
            leader: "姬兆兵",
            table: "详情",
        },
    ];
    useEffect(() => {
        let timer = null;
        if (isActive && scrollRef.current) {
            timer = setInterval(() => {
                if (!scrollRef.current)
                    return;
                const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
                const maxScroll = scrollHeight - clientHeight;
                if (maxScroll <= 0)
                    return;
                scrollRef.current.scrollTop =
                    scrollTop >= maxScroll ? 0 : scrollTop + 1;
            }, 50);
        }
        return () => {
            if (timer)
                clearInterval(timer);
        };
    }, [isActive]);
    return (_jsx("div", { style: tableStyles.container, children: _jsx("div", { style: {
                ...tableStyles.tableBodyWrapper,
                ...tableStyles.scrollbarHidden,
            }, children: _jsxs("table", { style: tableStyles.table, children: [_jsx("thead", { children: _jsx("tr", { children: timeTabs.map((tab, idx) => (_jsx("th", { style: {
                                    ...tableStyles.theadTh,
                                    ...(idx === timeTabs.length - 1
                                        ? tableStyles.lastCell
                                        : {}),
                                }, children: tab.name }, `th-${tab.value}`))) }) }), _jsx("tbody", { children: dataSource.map((row // 使用数据ID作为key
                        ) => (_jsx("tr", { children: timeTabs.map((tab, colIdx) => (_jsx("td", { style: {
                                    ...tableStyles.tableCell,
                                    ...(colIdx === timeTabs.length - 1
                                        ? tableStyles.lastCell
                                        : {}),
                                    ...(row.id === dataSource[dataSource.length - 1].id
                                        ? tableStyles.lastRow
                                        : {}),
                                }, children: row[tab.value] }, `${row.id}-${tab.value}`))) }, row.id))) })] }) }) }));
};
// 报废详情组件
const ScrapDetail = ({ isActive }) => {
    const scrollRef = useRef(null);
    const timeTabs = [
        { value: "requestDate", name: "发起时间" },
        { value: "requestDeptName", name: "发起部门" },
        { value: "subsystemLabel", name: "资产类型" },
        { value: "statusName", name: "任务进度" },
        { value: "detail", name: "详情" },
    ];
    const dataSource = [
        {
            id: "scrap-1",
            requestDate: "2025-09-10",
            requestDeptName: "综合管理部",
            subsystemLabel: "固定资产",
            statusName: "处理中",
            detail: "详情",
        },
        {
            id: "scrap-2",
            requestDate: "2025-09-02",
            requestDeptName: "综合管理部",
            subsystemLabel: "固定资产",
            statusName: "待报废",
            detail: "详情",
        },
        {
            id: "scrap-3",
            requestDate: "2025-09-01",
            requestDeptName: "财务资本部",
            subsystemLabel: "固定资产",
            statusName: "已销号",
            detail: "详情",
        },
        {
            id: "scrap-4",
            requestDate: "2025-08-14",
            requestDeptName: "科研创新中心",
            subsystemLabel: "固定资产",
            statusName: "待报废",
            detail: "详情",
        },
        {
            id: "scrap-5",
            requestDate: "2025-08-14",
            requestDeptName: "综合管理部",
            subsystemLabel: "固定资产",
            statusName: "待报废",
            detail: "详情",
        },
    ];
    useEffect(() => {
        let timer = null;
        if (isActive && scrollRef.current) {
            timer = setInterval(() => {
                if (!scrollRef.current)
                    return;
                const { scrollTop, scrollHeight, clientHeight } = scrollRef.current;
                const maxScroll = scrollHeight - clientHeight;
                if (maxScroll <= 0)
                    return;
                scrollRef.current.scrollTop =
                    scrollTop >= maxScroll ? 0 : scrollTop + 1;
            }, 50);
        }
        return () => {
            if (timer)
                clearInterval(timer);
        };
    }, [isActive]);
    return (_jsx("div", { style: tableStyles.container, children: _jsx("div", { ref: scrollRef, style: {
                ...tableStyles.tableBodyWrapper,
                ...tableStyles.scrollbarHidden,
            }, children: _jsxs("table", { style: tableStyles.table, children: [_jsx("thead", { children: _jsx("tr", { children: timeTabs.map((tab, idx) => (_jsx("th", { style: {
                                    ...tableStyles.theadTh,
                                    ...(idx === timeTabs.length - 1
                                        ? tableStyles.lastCell
                                        : {}),
                                }, children: tab.name }, `th-${tab.value}-${idx}`))) }) }), _jsx("tbody", { children: dataSource.map((row // 使用数据ID作为key
                        ) => (_jsx("tr", { children: timeTabs.map((tab, colIdx) => (_jsx("td", { style: {
                                    ...tableStyles.tableCell,
                                    ...(colIdx === timeTabs.length - 1
                                        ? tableStyles.lastCell
                                        : {}),
                                    ...(row.id === dataSource[dataSource.length - 1].id
                                        ? tableStyles.lastRow
                                        : {}),
                                }, children: row[tab.value] }, `${row.id}-${tab.value}`))) }, row.id))) })] }) }) }));
};
const PhysicalAssetOverview = ({ className = "", }) => {
    const [currentMenuIndex, setCurrentMenuIndex] = useState(0);
    const [showDetail, setShowDetail] = useState(true);
    const rotateTimer = useRef(null);
    const currentMenu = topMenu[currentMenuIndex];
    useEffect(() => {
        rotateTimer.current = setInterval(() => {
            setCurrentMenuIndex((prev) => (prev + 1) % topMenu.length);
            setShowDetail(true);
        }, 5000);
        return () => {
            if (rotateTimer.current) {
                clearInterval(rotateTimer.current);
            }
        };
    }, []);
    const getDetailComponent = () => {
        if (!currentMenu)
            return null;
        const isActive = true;
        switch (currentMenu.id) {
            case 1:
                return _jsx(PlanDetail, { isActive: isActive });
            case 2:
                return _jsx(CardDetail, { isActive: isActive });
            case 3:
                return _jsx(LedgerDetail, { isActive: isActive });
            case 4:
                return _jsx(WarehouseDetail, { isActive: isActive });
            case 5:
                return _jsx(ScrapDetail, { isActive: isActive });
            default:
                return null;
        }
    };
    const handleMenuClick = (index) => {
        setCurrentMenuIndex(index);
        setShowDetail((prev) => !prev);
        if (rotateTimer.current) {
            clearInterval(rotateTimer.current);
            rotateTimer.current = setInterval(() => {
                setCurrentMenuIndex((prev) => (prev + 1) % topMenu.length);
                setShowDetail(true);
            }, 5000);
        }
    };
    return (_jsxs("div", { className: `relative flex flex-col ${className}`, style: { height: "100%", boxSizing: "border-box" }, children: [_jsx("style", { children: `
        @keyframes breathe {
          0% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
          50% { transform: translate(-50%, -50%) scale(1.1); opacity: 0.8; }
          100% { transform: translate(-50%, -50%) scale(1); opacity: 1; }
        }
        @keyframes float {
          0% { transform: translate(-50%, -50%) translateY(0); }
          50% { transform: translate(-50%, -50%) translateY(-0.08rem); }
          100% { transform: translate(-50%, -50%) translateY(0); }
        }
        @keyframes pulse {
          0% { 
            transform: translate(-50%, -50%) scale(1); 
            box-shadow: 0 0 0 0 rgba(102, 252, 241, 0.4); 
          }
          70% { 
            transform: translate(-50%, -50%) scale(1.05); 
            box-shadow: 0 0 0 0.12rem rgba(102, 252, 241, 0); 
          }
          100% { 
            transform: translate(-50%, -50%) scale(1); 
            box-shadow: 0 0 0 0 rgba(102, 252, 241, 0); 
          }
        }
        .animate-breathe { animation: breathe 2s ease-in-out infinite; }
        .animate-float { animation: float 2.5s ease-in-out infinite; }
        .animate-pulse { animation: pulse 3s ease-in-out infinite; }
        ::-webkit-scrollbar { display: none; }
      ` }), _jsx("div", { className: "flex-1 relative overflow-hidden", children: _jsxs("div", { className: "absolute inset-x-0 top-1/2 transform -translate-y-1/2", style: { paddingTop: "0.20rem" }, children: [_jsxs("div", { className: "flex justify-center relative", children: [topMenu.map((item // 使用item.id作为key
                                ) => (_jsxs("div", { className: "animate-breathe cursor-pointer", style: {
                                        position: "absolute",
                                        left: `${item.pos.x}%`,
                                        top: `${item.pos.y}%`,
                                        ...(item.id === topMenu[currentMenuIndex].id
                                            ? tableStyles.activeMenu
                                            : tableStyles.inactiveMenu),
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        zIndex: 41,
                                        width: "0.47rem",
                                        height: "0.70rem",
                                    }, onClick: () => handleMenuClick(topMenu.findIndex((m) => m.id === item.id)), children: [_jsx("div", { style: {
                                                color: "#DEF0FF",
                                                fontSize: "0.18rem",
                                                textShadow: "0 0 0.08rem #66fcf1",
                                                position: "absolute",
                                                top: "-0.10rem",
                                                zIndex: 30,
                                                fontWeight: "bold",
                                            }, children: item.text === "盘点" ? "" : item.text }), item.text !== "盘点" && (_jsx("img", { src: topItem, style: {
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                marginBottom: "0.04rem",
                                            }, alt: item.text }))] }, item.id))), _jsx("div", { style: {
                                        position: "absolute",
                                        top: "6%",
                                        left: "50%",
                                        transform: "translate(-50%, -50%)",
                                        color: "#DEF0FF",
                                        fontSize: "0.24rem",
                                        fontWeight: "bold",
                                        textShadow: "0 0 0.12rem #DEF0FF",
                                        zIndex: 45,
                                    }, children: "\u76D8\u70B9" }), _jsx("img", { src: layerTopmost, style: {
                                        width: "2.36rem",
                                        height: "2.39rem",
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                        objectFit: "contain",
                                        zIndex: 40,
                                    }, alt: "\u6838\u5FC3\u56FE\u5F62" }), _jsx("img", { src: layerTop, style: {
                                        width: "5.19rem",
                                        height: "1.70rem",
                                        maxWidth: "100%",
                                        maxHeight: "100%",
                                        objectFit: "contain",
                                        position: "absolute",
                                        top: "0.7rem",
                                        zIndex: 40,
                                    }, alt: "\u9876\u5C42\u56FE\u5F62" }), showDetail && currentMenu && (_jsx("div", { className: "absolute z-70", onClick: (e) => e.stopPropagation(), style: {
                                        zIndex: 9999,
                                        left: `${currentMenu.pos.x}%`,
                                        top: `${currentMenu.pos.y}%`,
                                        transform: "translateY(-1.20rem)",
                                        pointerEvents: "auto",
                                    }, children: _jsx("div", { className: "relative bg-no-repeat bg-cover bg-center p-4", style: {
                                            backgroundImage: `url(${topInfo})`,
                                            boxSizing: "border-box",
                                            padding: "0.35rem 0 0 0.25rem",
                                            width: "3.7rem",
                                            height: "2.48rem",
                                            backgroundSize: "100% 100%",
                                        }, onClick: (e) => e.stopPropagation(), children: getDetailComponent() }) }, `detail-${currentMenu.id}`))] }), _jsxs("div", { className: "flex flex-col items-center relative", children: [_jsx("div", { className: "absolute left-1/2 top-1/2 transform -translate-x-1/2 -translate-y-1/2", style: { zIndex: 60, paddingTop: "0.7rem" }, children: _jsx("img", { src: centerBeamImg, style: {
                                            width: "0.78rem",
                                            height: "2.89rem",
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            objectFit: "contain",
                                            zIndex: 41,
                                        }, alt: "\u5149\u67F1\u80CC\u666F" }) }), assetItems.map((item // 使用item.id作为key
                                ) => (_jsxs("div", { className: "animate-float", style: {
                                        position: "absolute",
                                        left: `${item.pos.x}%`,
                                        top: `${item.pos.y}%`,
                                        transform: "translate(-50%, -50%)",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        zIndex: 20,
                                    }, children: [_jsx("div", { style: {
                                                color: "#DEF0FF",
                                                fontSize: "0.20rem",
                                                textShadow: "0 0 0.08rem #66fcf1",
                                                position: "absolute",
                                                top: "-0.18rem",
                                                zIndex: 30,
                                                fontWeight: "bold",
                                            }, children: item.text }), _jsx("img", { src: item.img, style: {
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                marginBottom: "0.04rem",
                                            }, alt: item.text })] }, item.id))), _jsx("div", { className: "flex justify-center w-full mt-[0.30rem]", style: { zIndex: 5 }, children: _jsx("img", { src: layerMiddle, style: {
                                            height: "1.62rem",
                                            width: "7.76rem",
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            objectFit: "contain",
                                        }, alt: "\u4E2D\u5C42\u73AF" }) })] }), _jsxs("div", { className: "flex justify-center relative", style: { zIndex: 5 }, children: [bottomMenu.map((menu // 使用menu.id作为key
                                ) => (_jsxs("div", { className: "animate-pulse", style: {
                                        position: "absolute",
                                        left: `${menu.pos.x}%`,
                                        top: `${menu.pos.y}%`,
                                        transform: "translate(-50%, -50%)",
                                        display: "flex",
                                        flexDirection: "column",
                                        alignItems: "center",
                                        zIndex: 10,
                                    }, children: [_jsx("img", { src: bottomItem, style: {
                                                width: "0.88rem",
                                                height: "0.57rem",
                                                maxWidth: "100%",
                                                maxHeight: "100%",
                                                objectFit: "contain",
                                            }, alt: menu.text }), _jsx("div", { style: {
                                                position: "absolute",
                                                top: "30%",
                                                left: "50%",
                                                transform: "translate(-50%, -50%)",
                                                color: "#DEF0FF",
                                                fontSize: "0.20rem",
                                                fontWeight: "bold",
                                                textShadow: "0 0 0.08rem #66fcf1",
                                            }, children: menu.text })] }, menu.id))), _jsx("div", { className: "flex justify-center w-full", style: { zIndex: 5 }, children: _jsx("img", { src: layerBottom, style: {
                                            width: "8.85rem",
                                            height: "2.72rem",
                                            maxWidth: "100%",
                                            maxHeight: "100%",
                                            objectFit: "contain",
                                        }, alt: "\u4E0B\u5C42\u73AF" }) })] })] }) })] }));
};
export default PhysicalAssetOverview;
